import React, { Component } from "react";
import { connect } from "react-redux";
import "./content.scss";
import alertIcon from "../../../assets/svg/alertBlue.svg";
import { Link } from "react-router-dom";
import alertsImg from "../../../assets/create-alerts.png";
import { Dimmer, Loader } from "semantic-ui-react";
import { setActiveModule } from "../../../actions/sideBarActions";

class CreateAlerts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // readMore: false
        };
    }

    componentDidMount() {}
    handleAlerts = () => {
        localStorage.setItem("activeModule", "Listening");
        this.props.setModule("Listening");
    };
    render() {
        return (
            <>
                <div className="gs_content">
                    <div className="left_content">
                        <div className="gs_header">
                            <img src={alertIcon} className="icon_content" />
                            <span className="content_title">Create Alerts</span>
                        </div>
                        <div className="text_content">
                            <p>{`Going through a Crisis and would like to track every single conversation happening around a topic of interest?  `}</p>

                            <p>{`Want to be alerted to the most impactful posts about your brand or competitors?`}</p>

                            <p>{`Would you like to be first to know if your post gets 5,000 likes or 100 comments?`}</p>

                            <p>{`Would you like to know if an influencer retweets you?`}</p>

                            <p>{`Well, we have just the thing for you.  Radarr has the most powerful social media alerting system in the world.  What’s more, it’s real time!`}</p>
                        </div>
                        <Link to="/alerts">
                            <button className="gs_link" onClick={this.handleAlerts}>
                                Create Alerts
                            </button>
                        </Link>
                    </div>
                    <div className="right_content">
                        <div id="gs_loader">
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                        <iframe
                            width="320px"
                            height="200px"
                            src="https://www.youtube.com/embed/pnxMNfWPmzQ?modestbranding=1"
                            title=""
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                            allowFullScreen
                            onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                            className="content_video"></iframe>
                        {/* <img className="content-img" src={alertsImg} width="350px" height="200px" /> */}
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        setModule: (data) => dispatch(setActiveModule(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateAlerts);
